import { ProductDetailViewModel } from '@models/api-search.models';
import { BasketLine } from '@core/services/basket/basket.model';

type MapToSendAsGift = {
    gift_item_id: string;
    gift_item_name: string;
    gift_price: number;
};

export const mapToSendAsGift = (product: Partial<ProductDetailViewModel | BasketLine>): Partial<MapToSendAsGift> => {
    if (!product) {
        return {};
    }

    return {
        gift_item_id: 'productNo' in product ? product.productNo : product.variantNo,
        gift_item_name: product.productName,
        gift_price: product.unitPriceRaw
    };
};
